import { IconPoppyLove } from 'components/icons/poppy-love';

export const UnauthenticatedEmptyStateImage = IconPoppyLove;
export const ErrorEmptyStateImage = IconPoppyLove;
